const colors = {
  primary: "#7533AF",
  heading: "#1F1F39",
};

export { colors };

// export const apiKey = 'http://localhost:8000'
// export const apiKey = "https://api.taswog.com";
export const apiKey = 'https://rmspro.taswog.com/api'

export const roles = [
  { label: "Home", value: "Home" },
  { label: "Dashboard", value: "Dashboard" },
  { label: "Setting", value: "Setting" },
  { label: "Items", value: "Items" },
  { label: "Management", value: "Management" },
  { label: "Delivery", value: "Delivery" },
  { label: "Outlet", value: "Outlet" },
  { label: "Reporting", value: "Reporting" },
  { label: "All Sales", value: "All Sales" },
  { label: "Screens", value: "Screens" },
  { label: "E-Commerce", value: "E-Commerce" },
  { label: "Accounting", value: "Accounting" },
  { label: "Promotion", value: "Promotion" },
  { label: "Customer Feedback", value: "Customer Feedback" },
  { label: "Feedback", value: "Feedback" },
  { label: "Purchase", value: "Purchase" },
  { label: "Waste", value: "Waste" },
  { label: "User Section", value: "User Section" },
  { label: "Role Management", value: "Role Management" },
];

export const systemUserRules = [
  "Home",
  "Dashboard",
  "Setting",
  "Items",
  "Management",
  "Delivery",
  "Outlet",
  "Reporting",
  "All Sales",
  "Screens",
  "E-Commerce",
  "Accounting",
  "Promotion",
  "Customer Feedback",
  "Feedback",
  "Purchase",
  "Waste",
  "User Section",
  "Role Management"
];


export const cashierRoles = [
  "All Sales",
];

export const riderRoles =[
  "Delivery",
];

export const displayUserRoles = [
  "Customer Feedback",
  "Feedback",
];

export const accountantRoles = [
  "Reporting",
  "Purchase",
  "All Sales",
  "Waste"
];

export const productManagerRoles = [
  "Items",
  "Management",
  "Promotion",
];
// export const apiKey = 'https://rmsapi.imdadyrms.co'
